import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import {
  LoggedInUserKeys,
  LoggedInUserService,
} from '../service/logged-in-user.service';

// Possible access token header names
export const ACCESS_TOKEN_HEADER_NAMES = [
  'Access-Token'
];

@Injectable()
export class AccessTokenInterceptor implements HttpInterceptor {
  constructor(private loggedInUserService: LoggedInUserService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap({
        next: (event) => {
          if (event instanceof HttpResponse && event.headers) {
            const accessToken = this.extractAccessToken(event.headers);

            if (accessToken) {
              this.storeAccessToken(accessToken);
            }
          }
        },
      })
    );
  }

  /**
   * Extract access token from response headers
   */
  private extractAccessToken(headers: any): string | null {
    for (const headerName of ACCESS_TOKEN_HEADER_NAMES) {
      const value = headers.get(headerName);

      if (value) {
        if (value.startsWith('Bearer ')) {
          return value.replace('Bearer ', '').trim();
        }
        return value;
      }
    }
    return null;
  }

  /**
   * Store access token in localStorage / user session
   */
  private storeAccessToken(token: string): void {
    try {
      const currentUser = this.loggedInUserService.getLoggedInUser(
        LoggedInUserKeys.LOGGED_IN_USER
      );
      if (currentUser) {
        const updatedUser = {
          ...currentUser,
          authToken: token,
        };
        this.loggedInUserService.setLoggedInUser(
          LoggedInUserKeys.LOGGED_IN_USER,
          updatedUser
        );
        console.log('Access token captured & stored');
      }
      // No logged-in user yet: skip storing a bare token string so we don't
      // overwrite the LOGGED_IN_USER object key with an inconsistent shape.
    } catch (error) {
      console.error('Error storing access token:', error);
    }
  }
}
